var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightedFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93965 0.961273V8.99593H0.780334V4.36055C0.937244 2.5064 2.50634 0.961273 4.38926 0.961273H8.93965Z",
    fill: "#56BFD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93965 10.6956V18.7302H4.23235C2.34943 18.7302 0.780334 17.1851 0.780334 15.331V10.6956H8.93965Z",
    fill: "#56BFD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.825 10.6956V15.331C18.825 17.1851 17.2559 18.7302 15.3729 18.7302H10.6656V10.6956H18.825Z",
    fill: "#56BFD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.825 4.36055V8.99593H10.6656V0.961273H15.3729C17.2559 0.961273 18.825 2.5064 18.825 4.36055Z",
    fill: "#56BFD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedFolders);
export default __webpack_public_path__ + "static/media/highlighted-folders.49fda4831457a641b2b8362bd51df86a.svg";
export { ForwardRef as ReactComponent };